import axios from 'axios';
import { API_BASE_URL } from 'shared/constants/appConfig';

export const quoteLinkApiClient = axios.create({
  baseURL: API_BASE_URL,
});
